import React, { useContext, useState } from 'react'
import { AppContext } from '@state/context'
import ButtonWithLoader from '@components/ButtonWithLoader'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Divider from '@components/Divider'
import Form from '@components/Form'
import {
  DIVIDER_SIZE,
  HEADING_TYPE,
  BUTTON_TYPE,
  TEXT_SIZES,
  TEXT_ALIGN,
  COLORS,
} from '@helpers/constants'
import { useUpdateCurrentUser } from '@hooks/mutations/useUpdateCurrentUser'
import { useCurrentUser } from '@hooks/useCurrentUser'

const UserAgreementPanel = () => {
  const [agreed, setAgreed] = useState(false)
  const { currentUser } = useCurrentUser()
  const [state] = useContext(AppContext)
  const {
    app: { userId },
  } = state

  const { post, isPosting } = useUpdateCurrentUser()

  return (
    <div className={'flex flex-col items-center'}>
      <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.LARGE}>
        Välkommen till Doklet!
      </Heading>
      <Divider size={DIVIDER_SIZE.SMALL} />

      <Text align={TEXT_ALIGN.LEFT}>
        Godkänn våra användarvillkor för att fortsätta.
      </Text>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <div className={'flex flex-row'}>
        <Form.Checkbox
          id={'user_agreement'}
          name={'user_agreement'}
          onChange={(e) => setAgreed(e.target.checked)}
        />
        <Form.Label htmlFor={'user_agreement'} className={''}>
          Jag godkänner Doklets{' '}
          <a
            href='https://doklet.se/anvandarvillkor-integritetspolicy/'
            target={'_blank'}
            rel='noreferrer'
            className={'underline ' + COLORS.PRIMARY_GREEN.TEXT}
          >
            användarvillkor & integritetspolicy
          </a>
        </Form.Label>
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <ButtonWithLoader
        type={BUTTON_TYPE.PRIMARY}
        disabled={!agreed}
        enabledText={'Okej'}
        isLoading={isPosting}
        handleClick={() => {
          post({
            acceptedEula: true,
            id: userId,
          })
        }}
      />
    </div>
  )
}

export default UserAgreementPanel
